import { RunContextApp }                    from "framework/RCApp"
import { useEffect, useState }              from "react"
import { ApiErrorInfo, ApiResponse }        from "types"

export interface ApiData<T> extends ApiResponse<T> {
  isLoading : boolean
}

export function useRequestApiData<T>(apimethod : (rc : RunContextApp, apiParams : any) => Promise<ApiResponse<T>>, 
                                     rc : RunContextApp, 
                                     apiParams : any,
                                     deps : any[] = []) : ApiData<T> {

  const [data, setData]           = useState<T>()
  const [error, setError]         = useState<ApiErrorInfo>()
  const [isLoading, setIsLoading] = useState(true)
 
  useEffect(() => {
    
    const request = async (rc : RunContextApp, apiParams : any) => {
      setIsLoading(true)
      const resp = await apimethod(rc, apiParams)
      setIsLoading(false)
      
      if (resp.error) {
        setData(undefined)
        setError(resp.error)
      } else {
        setError(undefined)
        setData(resp.data)
      }
    }

    request(rc, apiParams)

  }, [...Object.values(apiParams), ...deps])

  return {
    isLoading,
    data,
    error,
  }
}